export default __webpack_public_path__ + "static/media/50.17738379.jpeg";